import {NgModule} from '@angular/core';
import {StepSelectFileComponent} from './components/step-select-file/step-select-file.component';
import {DragDropFileUploadModule} from '@mydocma/component-library/src/lib/drag-drop-file-upload';
import {MatFormFieldModule} from '@angular/material/form-field';
import {TranslateModule} from '@ngx-translate/core';
import {MatSelectModule} from '@angular/material/select';
import {CommonModule} from '@angular/common';
import {MatInputModule} from '@angular/material/input';
import {MydocmaFormModule} from '@mydocma/component-library/src/lib/form';
import {MatStepperModule} from '@angular/material/stepper';
import {StepFileDataMappingComponent} from './components/step-file-data-mapping/step-file-data-mapping.component';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StepFilePreviewComponent} from './components/step-file-preview/step-file-preview.component';
import {AgGridModule} from 'ag-grid-angular';
import {MatIconModule} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import {CustomMatIconModule} from '@mydocma/component-library/src/lib/custom-mat-icon';
import {StepDataResultComponent} from './components/step-data-result/step-data-result.component';
import {MatDialogModule} from '@angular/material/dialog';
import {PromptDialogModule} from '@mydocma/component-library/src/lib/prompt-dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MydocmaStepperModule} from '../stepper/stepper.module';
import {CustomTooltipComponent} from './components/custom-tooltip.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ImportStepperComponent} from './components/import-stepper/import-stepper.component';

@NgModule({
    declarations: [
        StepSelectFileComponent,
        StepFileDataMappingComponent,
        StepFilePreviewComponent,
        StepDataResultComponent,
        CustomTooltipComponent,
        ImportStepperComponent
    ],
    imports: [
        CommonModule,
        DragDropFileUploadModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatStepperModule,
        MatTableModule,
        MydocmaFormModule,
        ReactiveFormsModule,
        TranslateModule,
        AgGridModule.withComponents([CustomTooltipComponent]),
        MatIconModule,
        CustomMatIconModule,
        MatDialogModule,
        PromptDialogModule,
        MatCheckboxModule,
        MatDividerModule,
        MydocmaStepperModule,
        MatTooltipModule
    ],
    exports: [
        MatStepperModule,
        StepSelectFileComponent,
        StepFileDataMappingComponent,
        StepFilePreviewComponent,
        StepDataResultComponent,
        CustomTooltipComponent,
        ImportStepperComponent
    ],
    entryComponents: [CustomTooltipComponent]
})
export class MydocmaImportModule {
}
